import { createContext, useState } from "react";

const LANGUAGES = {
	English: "en",
	French: "fr",
};

export const LanguageContext = createContext({
	language: null,
	changeLanguage: () => {},
});

const LanguageProvider = ({ children }) => {
	const [language, setLanguage] = useState(LANGUAGES.English);

	const changeLanguage = (lang) => {
		setLanguage(LANGUAGES[lang]);
	};

	const value = { language, changeLanguage };
	return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export default LanguageProvider;
